import React, { useState, useEffect, forwardRef } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm, Controller } from 'react-hook-form';
import SignatureCanvas from 'react-signature-canvas';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { FaCalendar, FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
registerLocale('es', es);
setDefaultLocale('es');
import PropTypes from 'prop-types';
import { ConvertErrors422ToString } from '../Utils/ConvertErrors422ToString';
import { Watch } from '@mui/icons-material';
import { ButtonGroup } from 'react-bootstrap';

const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <ButtonGroup>
        <input 
            id="buscar"
            type="text"
            placeholder="Buscar por nombre"
            aria-label="Search Input"
            value={filterText}
            onChange={onFilter}
        />
        <button className='clearbutton'
            type="button" onClick={onClear}>
            Buscar
        </button>
    </ButtonGroup>
);

FilterComponent.propTypes = {
    filterText: PropTypes.string.isRequired,
    onFilter: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        }}
        ref={ref}
        tabIndex={0}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}/>
        <FaCalendar size={20} style={{ marginLeft: '5px' }} />
    </button>
));

CustomInput.propTypes = {
    value: PropTypes.any,
    onClick: PropTypes.func,
};
export default function Usuarios(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [usuarios, setUsuarios] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [filterText, setFilterText] = useState('');
    const [perPage, setPerPage] = useState(10); 
    const [roles, setRoles] = useState([]);
    const [componentes, setComponentes] = useState([]);
    const [estados, setEstados] = useState([]);
    const [entidades, setEntidades] = useState([]);
    const [programasSecretaria, setProgramasSecretaria] = useState([]);
    const { handleSubmit, register, setValue, watch, control, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [firmaUsuario, setFirmaUsuario] = useState(null);
    const sigCanvasRef = React.useRef();
    const [firmaPenSize, setFirmaPenSize] = useState(2); // tamaño de lápiz para firmas
    const [isSigning, setIsSigning] = useState(false);

    function editing(row){
        return <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => EditarUsuario(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaUsers/>
                    </button>
                </div>
                
            </div>
    }
    
    useEffect(() => {
        InicializarFormulario();
        fetchData(currentPage, perPage, filterText);
    }, [currentPage, perPage, filterText]);
    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            fetchData(currentPage, perPage, filterText);
        };
        return (
            <FilterComponent 
                onFilter={e => setFilterText(e.target.value)} 
                onClear={handleClear} 
                filterText={filterText} 
            />
        );
    }, [filterText, currentPage, perPage]);
    const InicializarFormulario = async () => {
        const url = '/parametros/InicializarFormUsurios';
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setRoles(result.roles);
            setComponentes(result.componentes);
            setEstados(result.estadosusuario);
            setEntidades(result.entidades);
            setProgramasSecretaria(result.programaSecretarias);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    const fetchData = async (page, rowsPerPage, filter) => {
        const url = `/parametros/listarusuarios?page=${page}&limit=${rowsPerPage}&nombre=${filter}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setUsuarios(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    async function EditarUsuario (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('usr_nombre', row.usrNombre);
        setValue('usr_idpersona', row.usrIdpersona);
        setValue('usr_login', row.usrLogin);
        setValue('usr_password', row.estPassword);
        setValue('usr_rolid', row.usrRolid);
        setValue('usr_cargo', row.usrCargo);
        setValue('usr_email', row.usrEmail);
        setValue('usr_activo', row.usrActivo);
        setValue('usr_estadoid', row.usrEstadoid);
        setValue('usr_caducidad', row.usrCaducidad);
        setValue('usr_componenteid', row.usrComponenteid);
        setValue('usr_entidadid', row.usrEntidadid);
        setValue('usr_citas', row.usrCitas);
        setValue('usr_programasecretariaid', row.usrProgramasecretariaid);
        await consultarFirmaUsuario(row.id);
    };
    async function consultarFirmaUsuario(id){
        setCargando(true);
        const url = '/archivo/consultarfirmausuario';
        const obj = { usrId: id };
        try {
            setCargando(true);
            const response = await apiService.getFile(url, obj, token);
            // Recibes un Blob (image/png)
            const blob = response.data;
            if (blob && blob.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setFirmaUsuario(reader.result); // base64 para <img src=...>
                };
                reader.readAsDataURL(blob);
            } else {
                setFirmaUsuario(null);
            }
        } catch (error) {
            console.error('Error fetching firma usuario:', error);
            setFirmaUsuario(null);
        } finally {
            setCargando(false);
        }
    }
    const NuevoUsuario = () =>  {
        const now = new Date();
        setMuestraFormulario(true);
        setValue('id', 0);
        setValue('usr_nombre', '');
        setValue('usr_idpersona', '');
        setValue('usr_login', '');
        setValue('usr_password', '');
        setValue('usr_rolid', '0');
        setValue('usr_cargo', '');
        setValue('usr_email', '');
        setValue('usr_activo', false);
        setValue('usr_estadoid', '0');
        setValue('usr_caducidad', now);
        setValue('usr_componenteid', '0');
        setValue('usr_entidadid', '0');
        setValue('usr_citas', false);
        setValue('usr_programasecretariaid', '1');
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = (data.id === 0)?'/users/create':'/users/update';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar usuario', JSON.stringify(response.data.message));
                ResetForm();
                fetchData(currentPage, perPage, filterText)
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar usuario', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar usuario', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        const now = new Date()
        setValue('id', 0);
        setValue('usr_nombre', '');
        setValue('usr_idpersona', '');
        setValue('usr_login', '');
        setValue('usr_password', '');
        setValue('usr_rolid', '0');
        setValue('usr_cargo', '');
        setValue('usr_email', '');
        setValue('usr_activo', false);
        setValue('usr_estadoid', '0');
        setValue('usr_caducidad', now);
        setValue('usr_componenteid', '0');
        setValue('usr_entidadid', '0');
        setValue('usr_citas', false);
        setValue('usr_programasecretariaid', '1');
        setMuestraFormulario(false);
    }
    const firmaWidth = 600; 
    const firmaHeight = 200;
    const limpiarFirma = () => {
        sigCanvasRef.current.clear();
        setFirmaUsuario(null);
    };
    function dataURLtoBlob(dataurl) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }
    async function guardarActa(dataURL) {
        if (!dataURL) return;
        setCargando(true);
        const formData = new FormData();
        const pngBlob = dataURLtoBlob(dataURL);
        formData.append('file', pngBlob, 'USERFIRM.png');
        formData.append('usrId', watch('id'));  

        let url;
        url = '/archivo/uploadfilefirmausuario';
        try {
            const response = await apiService.uploaddoc(url, formData, token);
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if (error.status === 413) {
                Mensaje('Archivo demasiado grande', 'El archivo PDF supera el tamaño máximo permitido. Por favor, reduzca el tamaño del archivo e intente de nuevo.');
            } else if(error.status === 422){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            } else if(error.status === 409){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            } else {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
            
        } finally {
            setCargando(false);
        }
    }
    const guardarFirma = async () => {
        if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
            const canvas = sigCanvasRef.current.getCanvas();
            const dataUrl = canvas.toDataURL("image/png");
            setFirmaUsuario(dataUrl);
            guardarActa(dataUrl);
        }
    };
    useEffect(() => {
        if (isSigning) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isSigning]);
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Usuarios</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={'/'} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={'/parametros'} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Formulario Usuarios</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario usuario</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_nombre'>Nombres y apellidos</label>
                                                <input
                                                    {...register('usr_nombre', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Nombres y apellidos"
                                                    id='usr_nombre'/>
                                                {errors.usr_nombre && <p style={{color: 'red'}}>Digitar nombres y apellidos</p>}
                                                
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_idpersona'>Identificaci&oacute;n</label>
                                                <input {...register('usr_idpersona', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Identificaci&oacute;n"
                                                    id='usr_idpersona'/>
                                                {errors.usr_idpersona && <p style={{color: 'red'}}>Digitar Identificaci&oacute;n</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_login'>Nombre de usuario</label>
                                                <input {...register('usr_login', { required: true })} 
                                                        className="form-control" 
                                                        placeholder="Usuario"
                                                        id='usr_login'/>
                                                    {errors.usr_login && <p style={{color: 'red'}}>Digitar nombre de usuario</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_password'>Contrase&ntilde;a</label>
                                                <input type='password' {...register('usr_password', { required: true })} 
                                                        className="form-control" 
                                                        placeholder="Contrase&ntilde;a"
                                                        id='usr_password'/>
                                                    {errors.usr_password && <p style={{color: 'red'}}>Digitar contrase&ntilde;a</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-3">
                                            <label htmlFor='usr_rolid'>Rol:</label>
                                            <select {...register('usr_rolid', { required: true })} className='form-control' id='usr_rolid'>
                                                    <option value="">Seleccionar</option>
                                                    {roles.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.rolRol}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.usr_rolid && <p style={{color: 'red'}}>Seleccione rol</p>}
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_cargo'>Cargo</label>
                                                <input {...register('usr_cargo', { required: true })} 
                                                        className="form-control" 
                                                        placeholder="Cargo de usuario"
                                                        id='usr_cargo'/>
                                                    {errors.usr_cargo && <p style={{color: 'red'}}>Digitar cargo de usuario</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_email'>Correo electronico</label>
                                                <input {...register('usr_email', { required: true })} 
                                                        className="form-control" 
                                                        placeholder="Correo electronico"
                                                        id='usr_email'/>
                                                    {errors.usr_email && <p style={{color: 'red'}}>Digitar correo electronico</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='usr_programasecretariaid'>Programa/Secretar&iacute;a:</label>
                                                <select {...register('usr_programasecretariaid', { required: true })} className='form-control' id='usr_programasecretariaid'>
                                                        <option value="">Seleccionar</option>
                                                        {programasSecretaria.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.proPrograma}
                                                        </option>
                                                        ))}
                                                    </select>
                                                    {errors.usr_programasecretariaid && <p style={{color: 'red'}}>Seleccione programa o secretar&iacute;a</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor='usr_caducidad'>Fecha caducidad</label>
                                                <Controller
                                                        id="usr_caducidad"
                                                        control={control}
                                                        name="usr_caducidad"
                                                        render={({ field }) => (
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            />
                                                        )}
                                                    />
                                                    {errors.usr_caducidad && <p style={{color: 'red'}}>Digite fecha caducidad</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor='usr_estadoid'>Estado:</label>
                                            <select {...register('usr_estadoid', { required: true })} className='form-control' id='usr_estadoid'>
                                                    <option value="">Seleccionar</option>
                                                    {estados.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.estNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.usr_estadoid && <p style={{color: 'red'}}>Seleccione estado usuario</p>}
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor='usr_componenteid'>Componente:</label>
                                            <select {...register('usr_componenteid', { required: true })} className='form-control' id='usr_componenteid'>
                                                    <option value="">Seleccionar</option>
                                                    {componentes.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.comNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.usr_componenteid && <p style={{color: 'red'}}>Seleccione componente</p>}
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor='usr_entidadid'>Entidad:</label>
                                            <select {...register('usr_entidadid', { required: true })} className='form-control' id='usr_entidadid'>
                                                    <option value="">Seleccionar</option>
                                                    {entidades.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.entEntidad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.usr_entidadid && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('usr_activo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('usr_citas')}
                                                    className="custom-control-input" id="SwitchCitas"/>
                                                <label className="custom-control-label" htmlFor="SwitchCitas">Citas</label>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className='row'>
                                        <div style={{ marginBottom: 8 }}>
                                            <label>Tamaño de lápiz:&nbsp;</label>
                                            <input
                                                type="range"
                                                min={1}
                                                max={8}
                                                step={1}
                                                value={firmaPenSize}
                                                onChange={e => setFirmaPenSize(Number(e.target.value))}
                                                style={{ width: 120, verticalAlign: 'middle' }}
                                            />
                                            <span style={{ marginLeft: 8 }}>{firmaPenSize}px</span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className="form-group">
                                                <label>Firma del usuario</label>
                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 8 }}>
                                                    <SignatureCanvas
                                                        ref={sigCanvasRef}
                                                        penColor="black"
                                                        minWidth={firmaPenSize}
                                                        maxWidth={firmaPenSize}
                                                        canvasProps={{
                                                            width: firmaWidth,
                                                            height: firmaHeight,
                                                            className: "sigCanvas",
                                                            onPointerDown: () => setIsSigning(true),
                                                            onPointerUp: () => setIsSigning(false),
                                                            onMouseDown: () => setIsSigning(true),
                                                            onMouseUp: () => setIsSigning(false),
                                                            onTouchStart: () => setIsSigning(true),
                                                            onTouchEnd: () => setIsSigning(false)
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: 8 }}>
                                                    <button type="button" className="btn btn-secondary btn-sm" onClick={limpiarFirma}>Limpiar</button>
                                                    <button type="button" className="btn btn-info btn-sm" style={{ marginLeft: 8 }} onClick={guardarFirma}>Guardar firma</button>
                                                </div>
                                                {firmaUsuario && (
                                                    <div style={{ marginTop: 8 }}>
                                                        <img src={firmaUsuario} alt="Firma usuario" style={{ border: '1px solid #ccc', maxWidth: 350, maxHeight: 120 }} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button type='button' className='form-control' onClick={NuevoUsuario}>Nuevo</button>
                                {/* Pagination and filter controls can be added below if needed */}
                                <div>
                                    {subHeaderComponentMemo}
                                </div>
                                <h5>Lista de usuario</h5>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id</th>
                                            <th>Nombre usuario</th>
                                            <th>Usuario</th>
                                            <th>Rol</th>
                                            <th>Cargo</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usuarios.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            usuarios.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>{editing(row)}</td>
                                                    <td>{row.id}</td>
                                                    <td>{row.usrNombre}</td>
                                                    <td>{row.usrLogin}</td>
                                                    <td>{`${row.usrRolid} ${row.nombrerol}`}</td>
                                                    <td>{row.usrCargo}</td>
                                                    <td>{row.usrActivo ? 'Activo' : 'Inactivo'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}